import { extendVariants, Button, button } from "@nextui-org/react";

export const CustomButton = extendVariants(Button, {
  variants: {
    ...button.variants,
    variant: {
      ...button.variants.variant,
      "bordered-gray": "border border-secondary-800",
    },
    size: {
      ...button.variants.size,
      sm: "px-3 min-w-16 h-8 text-tiny gap-2 rounded-small",
      md: "px-4 min-w-22 h-10 text-small gap-2 rounded-medium",
      lg: "px-6 min-w-24 h-12 text-medium gap-3 rounded-large",
    },
    color: {
      ...button.variants.color,
      primary: "text-[#1A1A2E]",
    },
  },
  defaultVariants: {
    color: "primary",
    ...button.defaultVariants,
  },
  compoundVariants: [
    // @ts-expect-error NextUI problem
    ...button.compoundVariants,
    {
      variant: "light",
      color: "primary",
      // @ts-expect-error nextui problem
      class: "text-[#F8FCFD]",
    },
    {
      // @ts-expect-error NextUI problem
      class: "box-content min-w-[fit-content]",
    },
    {
      variant: "bordered-gray",
      color: "primary",
      // @ts-expect-error NextUI problem
      class: "bg-transparent text-primary",
    },
    {
      variant: "bordered-gray",
      color: "default",
      // @ts-expect-error NextUI problem
      class: "bg-transparent text-secondary-300",
    },
  ],
});
